const resources = {
  en: {
    skillsFactory: {
      title: 'Skills factory',
      description: 'Group repeating practice work into skills and keep daily tasks readable.',
      sections: {
        registryTitle: 'Skill registry',
        registryDescription: 'Review today’s skill tasks without changing the existing practice flow.',
        skillDescription: '{{count}} tasks scheduled today',
      },
      actions: {
        addSkill: 'Add skill',
        addTask: 'Add task',
        save: 'Save',
      },
      modals: {
        skill: {
          title: 'Add skill',
          name: 'Name',
        },
        task: {
          title: 'Add task',
          skill: 'Skill',
          titleLabel: 'Task',
        },
      },
      messages: {
        loadError: 'Failed to load data',
        skillAdded: 'Skill added',
        taskAdded: 'Task added',
      },
    },
  },
  uk: {
    skillsFactory: {
      title: 'Фабрика навичок',
      description: 'Об’єднуйте повторювану практику в навички та тримайте щоденні задачі читабельними.',
      sections: {
        registryTitle: 'Реєстр навичок',
        registryDescription: 'Переглядайте сьогоднішні задачі за навичками без змін у наявній логіці практики.',
        skillDescription: '{{count}} задач на сьогодні',
      },
      actions: {
        addSkill: 'Додати навичку',
        addTask: 'Додати задачу',
        save: 'Зберегти',
      },
      modals: {
        skill: {
          title: 'Додати навичку',
          name: 'Назва',
        },
        task: {
          title: 'Додати задачу',
          skill: 'Навичка',
          titleLabel: 'Задача',
        },
      },
      messages: {
        loadError: 'Не вдалося завантажити дані',
        skillAdded: 'Навичку додано',
        taskAdded: 'Задачу додано',
      },
    },
  },
}

export default resources
